import { type ReactNode } from 'react';
import { Box } from '@mantine/core';

type Props = {
  children: ReactNode;
};

export const LayoutContent = ({ children }: Props) => (
  <Box
    sx={theme => ({
      flex: 1,
      display: 'flex',
      flexWrap: 'wrap',
      overflowY: 'scroll',
      [`@media (min-width: ${theme.breakpoints.sm}px)`]: {
        flexWrap: 'nowrap',
        overflow: 'hidden',
      },
    })}
  >
    {children}
  </Box>
);
